import { service } from '@/utils/request'

export default {
  /**
   * @description 获取登录二维码
   * @param {{appId:String,proxyIp:String,type:String}} data
   * @returns
   */
  getLoginQrCode(data) {
    return service({
      url: `/cloud/weixin/gewe/login/getLoginQrCode`,
      method: 'post',
      data
    })
  },

  /**
   * @description 检查是否已扫码登录
   * @param {{appId:String,captchaCode:String,proxyIp:String,uuid:String}} data
   * @returns
   */
  checkQrCodeLogin(data) {
    return service({
      url: `/cloud/weixin/gewe/login/check`,
      method: 'post',
      data
    })
  },

  /**
   * @description 获取席位
   * @returns
   */
  getSeatList() {
    return service({
      url: `/cloud/weixin/gewe/login/seatList`,
      method: 'post'
    })
  },

  /**
   * @description 创建规则
   * @returns
   */
  addRule(data) {
    return service({
      url: `/cloud/weixin/rule/add`,
      method: 'post',
      data
    })
  },

  /**
   * @description 获取规则列表
   * @param {{page:String,size:String,searchKey:String}} params
   * @returns
   */
  getRuleList(params) {
    return service({
      url: `/cloud/weixin/rule/page`,
      method: 'post',
      params
    })
  },

  /**
   * @description 获取规则数据统计
   * @param {{page:String,size:String,searchKey:String}} data
   * @returns
   */
  getRuleStatistic(params) {
    return service({
      url: `/cloud/weixin/rule/statistic/page`,
      method: 'post',
      params
    })
  },

  /**
   * @description 获取群聊列表
   * @param {{page:Number,size:Number}} params
   * @param {{appId:String,memberCountEnd:Number,memberCountStart:Number,searchKey:String}} data
   * @returns
   */
  getChatroomList(params, data) {
    return service({
      url: `/cloud/weixin/gewe/chatroom/page`,
      method: 'post',
      params,
      data
    })
  },

  /**
   * @description 规则删除
   * @param  id
   * @returns
   */
  deleteRule(id) {
    return service({
      url: `/cloud/weixin/rule/delete/${id}`,
      method: 'post'
    })
  },

  /**
   * @description 规则详情
   * @param  id
   * @returns
   */
  getRuleDetail(id) {
    return service({
      url: `/cloud/weixin/rule/detail/${id}`,
      method: 'post'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/operateManage/wechat_push.js